var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.pageName,attrs:{"id":"app"}},[_c('Nav'),_c('router-view'),(_vm.showFooter)?_c('Footer'):_vm._e(),_c('a',{staticClass:"customerService",attrs:{"href":"https://www.wjx.cn/vm/t9gPiBR.aspx#","target":"_blank"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }